export default "__VITE_ASSET__DVrNH6Wp__"